import React, { RefObject } from 'react';
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import { Compass } from 'lucide-react';
import styles from './LessonContentRenderer.module.css';

interface ScrollPathProps {
    containerRef: RefObject<HTMLElement>;
    scrollContainerRef?: RefObject<HTMLElement>;
}

const ScrollPath: React.FC<ScrollPathProps> = ({ containerRef, scrollContainerRef }) => {
    // Track scroll of the 'target' (lesson content) within the 'container' (main scrollable div)
    const { scrollYProgress } = useScroll({
        container: scrollContainerRef,
        target: containerRef,
        offset: ["start start", "end end"]
    });

    // Dynamic color transition from primary to action
    const backgroundColor = useTransform(
        scrollYProgress,
        [0, 1],
        ["#2bb8d4", "#7c3aed"] // Cyan to Purple
    );



    // Smooth out the scroll progress for a premium feel
    const scaleY = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });

    return (
        <div className={styles.scrollPathContainer}>
            <div className={styles.scrollPathAnchor}>
                <Compass size={16} className={styles.scrollPathIcon} />
            </div>
            <div className={styles.scrollPathTrack} />
            <motion.div
                className={styles.scrollPathGlow}
                style={{ scaleY, originY: 0, backgroundColor }}
            />
        </div>
    );
};


export default ScrollPath;

